import { render, staticRenderFns } from "./PolicyDetailUpdateModal.vue?vue&type=template&id=90102100&scoped=true&"
import script from "./PolicyDetailUpdateModal.vue?vue&type=script&lang=js&"
export * from "./PolicyDetailUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90102100",
  null
  
)

export default component.exports